export class AnnotationTableIntersection {
  constructor(public annotationTypeName: string,
              public isIntersecting: boolean) {}
}
